/**
 * Clock URL Mode
 * 
 * Displays a clock in the URL hash using characters that build up over time.
 * - Even minutes: builds from left (0 to seconds), URL expands
 * - Odd minutes: builds from right (59 to 0), URL shrinks from full, filled from right
 * - Uses `|` (vertical pipes) at positions 0, 10, 20, 30, 40, 50 for dectenary separator
 * - Uses `/` (forward slashes) otherwise for regular seconds/flashes
 */

/**
 * Generate clock string for URL hash
 */
export function generateClockString(): string {
  const now = new Date();
  const seconds = now.getSeconds();
  const minutes = now.getMinutes();
  const isOddMinute = minutes % 2 === 1;

  // Helper to determine character at position i
  // Vertical pipes for dectenary separator (every 10 seconds)
  // Forward slashes for regular seconds/flashes
  const charAt = (i: number): string => {
    return (i % 10 === 0) ? '|' : '/';
  };

  if (isOddMinute) {
    // Odd minutes: start from full (60 chars at second 0) and go down like a stack
    // At second 0: 60 chars, at second 59: 1 char (only the leftmost)
    // Reduce from the right (end), keeping the leftmost characters
    const length = 60 - seconds;
    const chars: string[] = [];
    // Keep positions 0 to (length - 1) - removes from right side
    for (let i = 0; i < length; i++) {
      chars.push(charAt(i));
    }
    return chars.join('');
  } else {
    // Even minutes: build from left (0 to seconds)
    const chars: string[] = [];
    for (let i = 0; i <= seconds; i++) {
      chars.push(charAt(i));
    }
    return chars.join('');
  }
}

